import { Box,Tab,Tabs } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { TabPanelProps } from "../../types/helpers/types";
import { trackEventMatomo } from "../../helpers/matomo";
import NewNotifications from "./NewNotifications";
import NewTickets from "./NewTickets";

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function TicketsTabs() {
  const { t } = useTranslation('translation');
  const [value, setValue] = useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    trackEventMatomo('gestão de notificações e chamados', 'click', 'aba', newValue === 0 ? 'modelos de chamados' : 'modelos de notificações');
    setValue(newValue);
  };

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
        <Tabs textColor="secondary" indicatorColor="secondary" value={value} onChange={handleChange}>
          <Tab label={t('notificationsAndTickets.tickets.title')} value={0} />
          <Tab label={t('notificationsAndTickets.notifications.title')} value={1} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <NewTickets />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <NewNotifications />
      </CustomTabPanel>
    </>
  );
}
